import React from "react";
import { MapPin, Clock, Phone, Mail } from "lucide-react";
import heroImage from "../assets/zeamays.png";
import PageHero from "../components/PageHero";
const VisitUs = () => {
  return (
    <div className="w-full">
      <PageHero
        eyebrow="Visit our store"
        title="Come see Zea Mays Foods in person."
        description="Find us in Ikorodu for fresh pantry essentials, friendly service, and a convenient pickup and support experience."
        image={heroImage}
        imageAlt="Zea Mays Foods storefront"
        primaryAction={{ to: "/contact", label: "Contact Us" }}
        secondaryAction={{ to: "/products", label: "View Products" }}
        stats={[
          { label: "Store", value: "Ikorodu" },
          { label: "Hours", value: "Daily" },
          { label: "Support", value: "Phone + email" },
          { label: "Pickup", value: "Available" },
        ]}
        compact
      />
      <div className="min-h-screen bg-gradient-to-br from-green-400 to-green-50 px-6 py-16">
      <div className="max-w-6xl mx-auto text-center">
        <h1 className="text-5xl font-extrabold text-red-600 mb-4 pt-20 cursor-pointer">Visit Zea Mays Foods</h1>
        <p className="text-red-600 text-lg mb-12">
          Discover our store in person and enjoy our selection of traditional foods made with love and quality.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Info Section */}
          <div className="bg-green-100 shadow-lg rounded-2xl p-8 text-left">
            <h2 className="text-3xl font-bold text-red-800 mb-6">Our Store</h2>
            <div className="flex items-start mb-4">
              <MapPin className="text-red-500 w-6 h-6 mr-4 mt-1" />
              <p className="text-gray-700">
                No. 2, Ojo Akinbinu Street, Elepe, Ikorodu,Lagos.
              </p>
            </div>

            <div className="flex items-start mb-4">
              <Clock className="text-red-500 w-6 h-6 mr-4 mt-1" />
              <div>
                <p><strong>Mon - Fri:</strong> 9:00 AM – 6:00 PM</p>
                <p><strong>Sat:</strong> 10:00 AM – 4:00 PM</p>
                <p><strong>Sun:</strong> Closed</p>
              </div>
            </div>

            <div className="flex items-start mb-2">
              <Phone className="text-red-500 w-6 h-6 mr-4 mt-1" />
              <p>+234 7037038448</p>
            </div>

            <div className="flex items-start">
              <Mail className="text-red-500 w-6 h-6 mr-4 mt-1" />
              <p>zeamaysfoods@gmail.com</p>
            </div>

            <div className="flex items-start">
              <Mail className="text-red-500 w-6 h-6 mr-4 mt-1" />
              <p>Info@zeamaysfoods.com.ng</p>
            </div>
          </div>

          {/* Map Section (replace src with your own embed if needed) */}
          <div className="rounded-2xl overflow-hidden shadow-lg">
            <iframe
              title="Zea Mays Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1983.7853329280018!2d3.3792053160834463!3d6.524379322440288!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103bf44f5a98e62f%3A0xc98e2b14328b7f5e!2sLagos%2C%20Nigeria!5e0!3m2!1sen!2sng!4v1616662551885!5m2!1sen!2sng"
              width="100%"
              height="350"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-96"
            ></iframe>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default VisitUs;
